/* View switcher — sync all <view-switcher> instances on the page to the
   same active layout and apply data-layout on #product-grid.

   A page opens with its section's default (data-default-layout on
   #product-grid: compact for categories, grid for search results). A
   visitor's own choice is kept for that page only, until the visit ends
   (sessionStorage), so it survives filtering, sorting and load-more, while
   every other category, and every new visit, opens with the default again. */

(() => {
  if (customElements.get('view-switcher')) return;

  const STORAGE_KEY = 'products-layout';
  const pageKey = () => `${STORAGE_KEY}:${window.location.pathname}`;
  const pageDefault = () => {
    const grid = document.getElementById('product-grid');
    return (grid && grid.dataset.defaultLayout) || 'grid';
  };

  const getStored = () => {
    try { return sessionStorage.getItem(pageKey()) || pageDefault(); }
    catch (e) { return pageDefault(); }
  };
  const setStored = (v) => {
    try { sessionStorage.setItem(pageKey(), v); } catch (e) { /* ignore */ }
  };

  const applyToGrid = (value) => {
    document.querySelectorAll('#product-grid').forEach((g) => {
      g.dataset.layout = value;
    });
  };

  const syncAllSwitchers = (value) => {
    document.querySelectorAll('view-switcher').forEach((el) => {
      const order = (el.dataset.viewOrder || '').split(',').map((s) => s.trim()).filter(Boolean);
      const idx = order.indexOf(value);
      if (idx >= 0) el.style.setProperty('--vs-active-idx', String(idx));
      el.querySelectorAll('.view-switcher__btn').forEach((btn) => {
        btn.setAttribute('aria-pressed', btn.dataset.view === value ? 'true' : 'false');
      });
    });
  };

  class ViewSwitcher extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('.view-switcher__btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const value = btn.dataset.view;
          if (!value) return;
          setStored(value);
          applyToGrid(value);
          syncAllSwitchers(value);
        });
      });

      // First-mount hydration: apply the stored layout (or default).
      const initial = getStored();
      applyToGrid(initial);
      syncAllSwitchers(initial);
    }
  }

  customElements.define('view-switcher', ViewSwitcher);
})();
